const DAY_MS = 24 * 60 * 60 * 1000;

const MYSQL_DATETIME = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/;
export const parseApiDate = (value) =>
  new Date(MYSQL_DATETIME.test(value) ? `${value.replace(" ", "T")}Z` : value);

export const daysLeft = (value, now = Date.now()) =>
  value ? Math.max(0, Math.ceil((parseApiDate(value).getTime() - now) / DAY_MS)) : 0;
